<adapt-dialog [maxWidth]="500">
    <h3 adapt-dialog-title>{{isAdded ? "Schedule" : "Reschedule"}} {{culturalActivityTypeMetadata.shortTitle}}
        activity</h3>

    <div adapt-dialog-content
         class="d-flex flex-column gap-3">
        <div *ngIf="!activity.extensions.isSurvey"
             class="d-flex flex-row gap-3 justify-content-between">
            <div class="d-flex flex-column gap-2">
                <div *ngIf="activity.type === CulturalActivityType.CareerValuation
                    || activity.type === CulturalActivityType.CulturalIndex
                    || activity.type === CulturalActivityType.PeerCatchUp"
                     class="d-flex flex-column gap-1">
                    <h4>Participants</h4>
                    <adapt-link-person [personId]="activity.person1Id"
                                       [showImage]="true"
                                       imageSize="sm"></adapt-link-person>
                    <adapt-link-person [personId]="activity.person2Id"
                                       [showImage]="true"
                                       imageSize="sm"></adapt-link-person>
                </div>

                <div *ngIf="activity.teamId && (activity.type !== CulturalActivityType.PeerCatchUp || !isAdded)">
                    <h4>Team</h4>
                    <adapt-link-team [teamId]="activity.teamId"
                                     [showIcon]="true"></adapt-link-team>
                </div>

                <div *ngIf="activity.type === CulturalActivityType.PeerCatchUp && isAdded">
                    <adapt-select-catchup-team class="mb-4"
                                               [catchup]="temporaryPcu"
                                               (selectionChange)="activity.team = $event"
                                               (selectionValidityChange)="selectedTeamIsValid = $event"
                                               data-test="select-catch-up-team"></adapt-select-catchup-team>
                </div>
            </div>

            <div>
                <h4>When</h4>
                <dx-date-box [(value)]="activity.date"
                             [min]="today"
                             data-test="activity-due-date"></dx-date-box>
            </div>
        </div>

        <div *ngIf="activity.supplementaryData">
            <h4>Comment (optional)</h4>
            <adapt-html-editor [(contents)]="activity.supplementaryData.comment"
                               forceSize="compact"
                               data-test="reschedule-activity-comment-input"></adapt-html-editor>
        </div>
    </div>

    <div adapt-dialog-footer
         class="d-flex w-100">
        <button adaptButton="delete"
                *ngIf="showDeleteButton"
                [adaptBlockingClick]="deleteActivity"></button>
        <adapt-standard-dialog-buttons [saveIsDisabled]="isInvalidOrNoChanges"
                                       [saveBlockingClick]="saveAndClose"
                                       (cancelClick)="cancel()"></adapt-standard-dialog-buttons>
    </div>
</adapt-dialog>
